import React, { useState, useEffect } from 'react';
import { Navigation } from './Navigation';
import { Toaster } from '../ui/sonner';
import TrialBanner from '../billing/TrialBanner';
import UpgradeModal from '../billing/UpgradeModal';

// Single app-wide upgrade modal, opened via the 'lifely:open-upgrade' window event
// (dispatched by PlanContext.openPlansModal and the trial banner).
function GlobalUpgradeModal() {
  const [open, setOpen] = useState(false);
  const [trigger, setTrigger] = useState('upgrade_prompt');

  useEffect(() => {
    const handler = (e) => {
      setTrigger(e.detail?.trigger || 'upgrade_prompt');
      setOpen(true);
    };
    window.addEventListener('lifely:open-upgrade', handler);
    return () => window.removeEventListener('lifely:open-upgrade', handler);
  }, []);

  return <UpgradeModal isOpen={open} onClose={() => setOpen(false)} trigger={trigger} />;
}

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation />
      <main className="max-w-7xl mx-auto px-6 lg:px-12 py-8 lg:py-12">
        <TrialBanner />
        {children}
      </main>
      <Toaster position="bottom-right" />
      <GlobalUpgradeModal />
    </div>
  );
};

export default Layout;
